import { FormGroup, TagInput } from "@blueprintjs/core"
import React, { Component } from "react"
import classNames from "utils/classNames"
import { withFormController } from "../Molecules/FormController"

class CustomTagInput extends Component {
  state = {
    errorMessage: null,
  }
  handleChange = values => {
    const { path, onChange, regex, errorMessage } = this.props

    if (regex) {
      const invalidInputs = regex
        ? values.filter(value => !regex.test(value))
        : []

      if (invalidInputs.length > 0) {
        this.setState({ errorMessage: errorMessage })
      } else {
        this.setState({ errorMessage: null })
      }
    }

    onChange &&
      onChange(path, regex ? values.filter(value => regex.test(value)) : values)
  }

  render() {
    const {
      value,
      error,
      helperText,
      intent,
      labelProps,
      inline,
      label,
      labelInfo,
      onChange,
      big,
      round,
      fill,
      onAdd,
      onRemove,
      ...OtherTagInputProps
    } = this.props
    const { errorMessage } = this.state

    return (
      <FormGroup
        className={classNames(
          "vt-custom-text-input",
          "vt-custom-tag-input",
          labelProps,
          {
            "vt-tag-input-big": big,
            "vt-input-rounded": round,
            "vt-input-stretch": fill,
          }
        )}
        inline={inline}
        label={label}
        intent={error || errorMessage ? "danger" : undefined}
        labelInfo={labelInfo}
        helperText={error || errorMessage || helperText}
      >
        <TagInput
          values={value}
          onChange={this.handleChange}
          intent={error || errorMessage ? "danger" : undefined}
          {...OtherTagInputProps}
        />
      </FormGroup>
    )
  }
}

CustomTagInput.defaultProps = {
  value: [],
  big: true,
}

export default withFormController(CustomTagInput)
